import React, { useRef, useState } from 'react'
import '../styles/App.css'
import { Outlet, useLocation } from 'react-router-dom'
import { useTheme } from '../context/ThemeContext'
import { useMusic } from '../context/MusicContext'
import ThemeToggle from '../components/ThemeToggle'
import PageTransition from '../components/layout/PageTransition'
import PlayerSection from '../components/player/PlayerSection'
import ExpandedCover from '../components/cover/ExpandedCover'
import { usePWA } from '../hooks/usePWA'
import { useThemeDocumentEffects } from '../hooks/useThemeDocumentEffects'

export default function MainLayout() {
  const { isDarkMode } = useTheme()
  const bottomRef = useRef(null)
  const playerRef = useRef(null)
  const location = useLocation()
  const { currentTrack, API_URL } = useMusic()
  const [isExpanded, setIsExpanded] = useState(false)
  const isPWA = usePWA()

  useThemeDocumentEffects(isDarkMode)

  return (
    <div className="App" data-theme={isDarkMode ? 'dark' : 'light'}>
      <ThemeToggle />
      {location.pathname === '/' && !isPWA && (
        <div className="content-header">
          <h1>Musik App</h1>
        </div>
      )}

      <PageTransition>
        <Outlet />
      </PageTransition>

      <PlayerSection
        bottomRef={bottomRef}
        playerRef={playerRef}
        isExpanded={isExpanded}
        setIsExpanded={setIsExpanded}
      />

      <ExpandedCover
        playerRef={playerRef}
        isExpanded={isExpanded}
        setIsExpanded={setIsExpanded}
        currentTrack={currentTrack}
        API_URL={API_URL}
      />
    </div>
  )
}
